var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8e8e98;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #363c4f;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17 28 17 17.5 6 14.5 6 25 17 28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.5,19.44c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.27-.22,.49-.5,.49h0c-.28,0-.5-.22-.5-.49Zm0-1.5c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.27-.22,.49-.5,.49h0c-.28,0-.5-.22-.5-.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17 28 17 17.5 25 12 25 22.5 17 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25 12 17 17.5 6 14.5 14 9 25 12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14,15.8c-.13,0-.26-.06-.35-.15-.1-.09-.15-.22-.15-.35s.05-.26,.15-.36c.18-.18,.52-.18,.7,0,.1,.1,.15,.23,.15,.36s-.05,.26-.15,.35c-.09,.09-.22,.15-.35,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.5,13.75c0-.27,.22-.5,.5-.5h0c.28,0,.5,.23,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Zm0-1.55c0-.27,.22-.49,.5-.49h0c.28,0,.5,.22,.5,.49h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14,11.16c-.13,0-.26-.05-.35-.15-.05-.04-.09-.1-.11-.16-.03-.06-.04-.13-.04-.19,0-.13,.05-.26,.15-.36,.14-.13,.36-.18,.54-.1,.06,.02,.12,.06,.16,.1,.1,.1,.15,.23,.15,.36,0,.06-.01,.13-.04,.19-.02,.06-.06,.12-.11,.16-.09,.1-.22,.15-.35,.15Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.09 18.04 5.87 14.98 6.13 14.02 16.91 16.96 24.72 11.59 25.28 12.41 17.09 18.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.5,
    y: 20.21,
    width: 1,
    height: 6.22,
    transform: "translate(-1.86 44.2) rotate(-74.76)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,23c-.13,0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35s.05-.26,.15-.35c.18-.19,.52-.19,.7,0,.1,.09,.15,.22,.15,.35s-.05,.26-.15,.35c-.09,.1-.22,.15-.35,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.03,22.47c-.26-.07-.42-.35-.34-.61h0c.07-.27,.35-.42,.61-.35h0c.27,.07,.42,.35,.35,.61h0c-.06,.23-.26,.37-.48,.37h0c-.05,0-.09,0-.14-.02Zm-1.83-.51c-.27-.07-.42-.35-.35-.62h0c.08-.26,.35-.42,.62-.34h0c.26,.07,.42,.35,.34,.61h0c-.06,.22-.26,.37-.48,.37h0s-.09-.01-.13-.02Zm-1.83-.51c-.27-.07-.43-.35-.35-.62h0c.07-.26,.35-.42,.62-.34h0c.26,.07,.42,.35,.34,.61h0c-.06,.22-.26,.37-.48,.37h0s-.09,0-.13-.02Zm-1.84-.51c-.26-.08-.42-.35-.35-.62h0c.08-.26,.35-.42,.62-.34h0c.27,.07,.42,.35,.35,.61h0c-.06,.22-.26,.37-.48,.37h0c-.05,0-.09-.01-.14-.02Zm-1.83-.51c-.27-.08-.42-.35-.35-.62h0c.08-.26,.35-.42,.62-.35h0c.26,.08,.42,.35,.34,.62h0c-.06,.22-.26,.37-.48,.37h0s-.09,0-.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14,19.94c-.13,0-.26-.06-.35-.15-.1-.09-.15-.22-.15-.35,0-.14,.05-.26,.15-.36,.14-.14,.36-.18,.54-.11,.06,.03,.12,.07,.16,.11,.1,.09,.15,.22,.15,.36,0,.13-.05,.26-.15,.35-.09,.09-.22,.15-.35,.15Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.42,
    y: 26.3,
    width: 6.16,
    height: 1,
    transform: "translate(-15.01 7.11) rotate(-35.78)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14,19.94c-.13,0-.26-.06-.35-.15-.1-.09-.15-.22-.15-.35,0-.14,.05-.26,.15-.36,.14-.14,.36-.18,.54-.11,.06,.03,.12,.07,.16,.11,.1,.09,.15,.22,.15,.36,0,.13-.05,.26-.15,.35-.09,.09-.22,.15-.35,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.19,24.17c-.16-.22-.1-.53,.12-.69h0c.23-.16,.54-.1,.7,.12h0c.16,.23,.1,.54-.12,.7h0c-.09,.06-.19,.09-.29,.09h0c-.16,0-.31-.08-.41-.22Zm1.6-1.11c-.16-.23-.1-.54,.12-.7h0c.23-.15,.54-.1,.7,.13h0c.16,.23,.1,.54-.12,.69h0c-.09,.07-.19,.09-.29,.09h0c-.16,0-.31-.07-.41-.21Zm1.6-1.11c-.16-.23-.1-.54,.13-.7h0c.22-.16,.53-.1,.69,.13h0c.16,.22,.1,.54-.12,.69h0c-.09,.06-.19,.09-.29,.09h0c-.16,0-.31-.07-.41-.21Zm1.6-1.12c-.16-.22-.1-.54,.13-.69h0c.22-.16,.53-.1,.69,.12h0c.16,.23,.1,.54-.12,.7h0c-.09,.06-.19,.09-.29,.09h0c-.16,0-.31-.08-.41-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6,25.5c-.13,0-.26-.05-.35-.15-.05-.04-.09-.1-.11-.16-.03-.06-.04-.13-.04-.19,0-.13,.05-.26,.15-.35,.19-.19,.52-.19,.7,0,.1,.09,.15,.22,.15,.35,0,.06-.01,.13-.04,.19-.02,.06-.06,.12-.11,.16-.09,.1-.22,.15-.35,.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.09,28.54l-11.59-3.16V14.24l8.41-5.78,11.59,3.16v11.15l-8.41,5.78Zm-10.59-3.93l10.41,2.84,7.59-5.22V12.38l-10.41-2.84-7.59,5.22v9.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.5,
    y: 3,
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.5 5.21 14 3.71 12.5 5.21 11.79 4.5 14 2.29 16.21 4.5 15.5 5.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.59 29.58 .44 29.01 .89 25.75 1.88 25.89 1.56 28.2 3.77 28.6 3.59 29.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.86 25.72 28.43 24.82 30.34 23.9 29.43 21.99 30.34 21.56 31.66 24.37 28.86 25.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.5,
    y: 17.5,
    width: 1,
    height: 10.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/Move.db4520b5ae62d362ccf397ac28cd6e20.svg";
export { ForwardRef as ReactComponent };